<template>
    <vgloballayout
        :loading="loading"
        :error="error"
        @reload="getProfileInfo"
    >
		<div class="profile" slot=body>
			<h1>Учетные данные</h1>

			<!-- Форма почты -->
			<el-form ref="form" :model="formEmail">
				
				<el-form-item label="Логин"> 
					<el-row type="flex" justify="space-between">
						<el-col :span="12">
							<el-input 
								v-model="formEmail.email" 
								size="small"
								@input="isLoginInUse(formEmail.email, 'email')"
								:disabled="true"
								>
									<i class="fas" slot="suffix" :class="formEmail.isEmailConfirmed ? 'fas fa-check-circle color-green' : 'fa-exclamation-circle color-orange'"  style="margin: 10px"></i>
							</el-input>     
						</el-col>
						<el-col :span="12" class="m-l-10">                       
							<div v-if="!formEmail.isEmailConfirmed && testMail" class="color-orange phone-confirm" @click="emeilConfirm()">Подтвердить почту</div>
						</el-col>
					</el-row>
				</el-form-item>
						
				<div class="phone-hidden" v-show="formEmail.hide">
					<el-form :inline="true" :model="formEmail" class="demo-form-inline">
						<p class="text-confirmed">На указанную почту придет письмо с кодом. Введите его в поле ниже:</p>
						<div class="phone-hidden__wrap credentials-input">
							<el-form-item>
								<span>Код:</span>
							</el-form-item>

							<el-form-item>
								<el-input 
									v-model="formEmail.code" 
									size="small"
									>
								</el-input>
							</el-form-item>

							<el-form-item>
								<el-button type="primary" size="small" @click="confirmEmail" :loading="formEmail.loading">Подтвердить</el-button>
							</el-form-item>
						</div>
					</el-form>
				</div>

			</el-form>

			<!-- Форма изменения телефона -->
<!-- 			<el-form ref="form" :model="formPhone" class="m-t-25">
				
				<el-form-item label="Телефон"> 
					<el-row type="flex" justify="space-between">
						<el-col :span="12">
							<el-input 
								v-model="formPhone.phone" 
								size="small"
								@input="isLoginInUse(formPhone.phone, 'phone')"
								v-mask="'+7 ### ### ## ##'"
								maxlength="16"
								placeholder="+7"
								>
								<i class="fas" slot="suffix" :class="formPhone.isPhoneConfirmed ? 'fas fa-check-circle color-green' : 'fa-exclamation-circle color-orange'"  style="margin: 10px"></i>
							</el-input>     
						</el-col>
						<el-col :span="12" class="m-l-10">                       
							<div v-if="!formPhone.isPhoneConfirmed && testPhone" class="color-orange phone-confirm" @click="phoneConfirm()">Подтвердить номер телефона</div>
						</el-col>
					</el-row>
				</el-form-item>

				<div class="phone-hidden body-1" v-show="formPhone.hide">
					<p class="body-1 text-confirmed">На указанный номер телефона придет СМС сообщение с одноразовым кодом. Введите его в поле ниже:</p>
					<el-form :inline="true" :model="formPhone" class="demo-form-inline">
						<div class="phone-hidden__wrap credentials-input">

							<el-form-item>
								<span class="body-1">Код из СМС:</span>
							</el-form-item>

							<el-form-item>
								<el-col>
									<el-input 
										v-model="formPhone.code" 
										size="small"
										>
									</el-input>
								</el-col>
							</el-form-item>

							<el-form-item>
								<el-button type="primary" size="small" @click="confirmPhoneNumber()" :loading="formPhone.loading">Подтвердить</el-button>
							</el-form-item>

						</div>
					</el-form>
					<span> <el-button @click="phoneConfirmReset()" type="text"  v-if="timer == 0">Повторить</el-button><span class="m-l-10">Повторная отправка доступна через {{ timer }} сек.</span></span>
				</div>

			</el-form> -->

			<!-- ФОРМА ПАРОЛЯ -->
			<el-form ref="formPas" :model="formPas"   autocomplete="new-password">
				<h1 class="m-t-45">Изменить пароль</h1>
				<el-row type="flex" justify="space-between">
					<el-col :span="12">
						<el-form-item label="Старый пароль">
							<el-input 
							v-model="formPas.oldpassword" 
							size="small"
							show-password
							autocomplete="off"
							name="foo"
							type="password"
							>
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row type="flex" justify="space-between">
					<el-col :span="12">
						<el-form-item label="Пароль">
							<el-input 
							v-model="formPas.password" 
							size="small"
							show-password
							type="password"
							>
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row type="flex" justify="space-between">
					<el-col :span="12">
						<el-form-item label="Повторите пароль">
							<el-input 
							v-model="formPas.repassword" 
							size="small"
							show-password
							type="password"
							>
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				
				<el-form-item  class="m-t-25">
					<el-button size="small" type="primary" @click="onSubmitPas" :loading="formPas.loading">Сохранить пароль</el-button>
				</el-form-item>
			</el-form>
		</div>
	</vgloballayout>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            error: false,
            formEmail: {
                oldEmail: '',
                email: '',
                isEmailConfirmed: false,
                loading: false,
                hide: false
            },
            formPhone: {
                oldPhone: '',
                phone: '',
                isPhoneConfirmed: false,
                loading: false,
                code: '',
                hide: false
            },
            formPas: {
                oldpassword: '',
                password: '',
                repassword: '',
                loading: false
            },
            timer: 60
        }
    },
    mounted() {
        this.getProfileInfo()
    },
	computed: {
		testPhone() {
			let test = /(\+7|8)[- _]*\(?[- _]*(\d{3}[- _]*\)?([- _]*\d){7}|\d\d[- _]*\d\d[- _]*\)?([- _]*\d){6})/g.test(this.formPhone.phone)
			return test
		},
		testMail() {
			let test = /^[-._a-z0-9]+@(?:[a-z0-9][-a-z0-9]+\.)+[a-z]{2,6}$/.test(this.formEmail.email)
			return test
		},
	},
    methods: {
        async getProfileInfo() {
			this.loading = true
			this.error = false

            try {
                let query = await this.$store.dispatch('getProfileInfo')

                this.formEmail.oldEmail = query.email
                this.formEmail.email = query.email
                this.formEmail.isEmailConfirmed = query.isEmailConfirmed

                this.formPhone.oldPhone = query.phone
                this.formPhone.phone = query.phone
                this.formPhone.isPhoneConfirmed = query.isPhoneConfirmed

            } catch(e) {
                this.error = this.$ErrorsMod(e)
			}
			this.loading = false
        },

		async emeilConfirm () {
			this.formEmail.loading = true
			try {				
				this.formEmail.oldEmail = this.formEmail.email
				await this.$store.dispatch('sendConfirmLogin', this.formEmail.email)
				this.formEmail.hide = true
			} catch (e) {
				this.$ErrorsMod(e)
			}
			this.formEmail.loading = false
		},

        async onSubmitPas() {
			if((this.formPas.password == this.formPas.repassword) ) {
				try {
					await this.$store.dispatch('changePassword', {
						oldPassword: this.formPas.oldpassword,
						newPassword: this.formPas.password
					})
					this.$message({
						message: 'Пароль изменён',
						type: 'success'
					})
				} catch(e) {
					this.$ErrorsMod(e)
				}
			} else {
				this.$message([{
					message: 'Пароли не совпадают',
					code: 'error'
				}])
			}
        },

		phoneConfirmReset() {
			this.timer = 60
			this.phoneConfirm()
		},


		async phoneConfirm() {
			try {
				let phone = parseInt(this.formPhone.phone.replace(/\D+/g,""));

                let inetval
                
				if(this.timer == 60) {
					await this.$store.dispatch('sendConfirmLogin', phone)
					this.formPhone.hide = true
					inetval = setInterval(() => {
						if(this.timer > 0) {
							this.timer--
						} else {
							clearInterval(inetval)
						}						
					}, 1000);
				} else if(this.timer == 0) {
					clearInterval(inetval)
					this.phoneConfirmReset()
				} else {
					this.$message({
						message: `Должно пройти ${this.timer} сек.`,
						type: 'error'
					});
				}
			} catch(e) {
                this.$ErrorsMod(e)
			}
        },

		async confirmEmail() {
			try {
				await this.$store.dispatch('changeLogin', {
					login: this.formEmail.email,
					code: this.formEmail.code
				})
                this.$message({
                	message: 'Сохранено',
                	type: 'success'
                });
				this.formEmail.isEmailConfirmed = true
				this.formEmail.hide = false
			} catch(e) {
				this.$ErrorsMod(e)
			}
		},

		async isLoginInUse(login, type) {

			if(type == 'email') {
				if(this.formEmail.oldEmail !== this.formEmail.email) {
					this.formEmail.isEmailConfirmed = false
				} else {
					this.formEmail.isEmailConfirmed = true
				}
			} else if(type == 'phone') {

				let phone = '+' + parseInt(this.formPhone.phone.replace(/\D+/g,"")) //трубруется так как v-mask подставляет масску телефона

				if(this.formPhone.oldPhone !== phone) {
					this.formPhone.isPhoneConfirmed = false
				} else {
					this.formPhone.isPhoneConfirmed = true
				}
			}

		},

		async confirmPhoneNumber() {
			let phone = parseInt(this.formPhone.phone.replace(/\D+/g,""));
			try {
				await this.$store.dispatch('changeLogin', {
					login: phone,
					code:  this.formPhone.code
				})

                this.$message({
                	message: 'Сохранено',
                	type: 'success'
				});

				this.formPhone.isPhoneConfirmed = true
				this.formPhone.hide = false
				this.formPhone.hide = false
				this.formPhone.code = ''
				this.formPhone.oldPhone = '+' + parseInt(this.formPhone.phone.replace(/\D+/g, '')) // трубруется так как v-mask подставляет масску телефона

			} catch(e) {
				this.$ErrorsMod(e)
			}
		},
    }
}
</script>

<style scoped>
    .el-form-item {
        margin-bottom: 10px;
    }

</style>

<style>
    .profile .el-form-item__label {
        float: none;
    }
	
	.phone-confirm {
		cursor: pointer;
	}

	.text-confirmed {
		padding: 10px;
		background: #F5F5F5;
		border: 1px solid #EDEDED;
		border-radius: 3px;
		color: #e60000;
		font-weight: 300;
		font-size: 14px;
	}
</style>
